<template>
  <div>
    <div :style="toptype==1?'':'background-color: #3866bc;'">
      <el-row>
        <el-col :span="4">
          <div class="flex justify-center align-center img_all">
            <el-image class="logo_img" :src="require('../../static/assets/images/login/logo.png')" v-if="toptype==1"></el-image>
            <el-image class="logo_img" :src="require('../../static/assets/images/logo/logo-white.png')" v-else></el-image>
            <!-- <div style="color: #fff;">LOGO</div> -->
          </div>
        </el-col>
        <el-col :span="17">
          <div class="response navall">
            <div class="flex justify-center align-center marginauto navcon">
              <template v-for="(item,index) in toplist">
                <template v-if="item.childs">
							<el-popover placement="bottom" width="50px" trigger="hover">
								<div class="tttta" v-for="eitem in item.childs"  @click="changenav(eitem.path,index)">
									{{ eitem.title }}
								</div>
                <div slot="reference" class="toponenew text-center pointer"   :style="screenWidth<1680?screenWidth<1530?'padding: 0 15px;font-size:15px':'padding: 0 30px;font-size:15px':''" :class="toptype == item.type ? 'activenew' : ''">
                <span :style="toptype==1?'color: #171717;':''">
                  {{item.title}}
                </span>
              </div>
							</el-popover>
						</template>
              <div class="toponenew text-center pointer" v-else  :style="screenWidth<1680?screenWidth<1530?'padding: 0 15px;font-size:15px':'padding: 0 30px;font-size:15px':''" :class="toptype == item.type ? 'activenew' : ''"   @click="changenav(item.path,index)">
                <span :style="toptype==1?'color: #171717;':''">
                  {{item.title}}
                </span>
              </div>
              </template>

               
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div>
            <div v-if="!name" class="flex justify-center align-center">
              <div class="login_text pointer" :style="toptype==1?'color: #0066d9;':'color: #fff;'"><a @click="logchang(1)" :style="toptype==1?'color: #0066d9;':'color: #fff;'">登录</a> / <a @click="logchang(2)"  :style="toptype==1?'color: #0066d9;':'color: #fff;'">注册</a></div>
            </div>
            <div v-if="name" class="flex justify-center align-center" style="margin-left: 10px;height: 65px;">
              <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      <div class="header_rig_tt_let" slot="reference" style="display: flex;align-items: center;cursor: pointer;">
                        <div style="width:60px;text-align: center;color: #fff; overflow:hidden;white-space:nowrap; text-overflow:ellipsis;">{{name}}</div>
                        <i class="el-icon-arrow-down" style="font-size: 14px;margin-top:2px;color: #fff;"></i>
                      </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="2">个人中心</el-dropdown-item>
                      <el-dropdown-item command="1">退出登录</el-dropdown-item>
                      
                    </el-dropdown-menu>
                  </el-dropdown>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
      
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import cookies from 'js-cookie'
export default {
  name: 'topnav',
  // computed: {
  //     ...mapGetters(["name"])
  // },
  props: {
    logtype:{
      type: [Number,String],
      default: 1
    },
    isIndex: {
      type: Boolean,
      default: false
    },
    toptype: {
      type: [Number,String],
      default: 1
    },
    keywords: {
      type:String,
      default: ''
    },
    types: {
      type: [Number,String],
      default: '1'
    },
    isSearch: {
      type: [Number,String],
      default: 0
    }
  },
  data(){
    return{
      name:'',
      screenWidth:1920,
      keyword: '',
      selectid: '1',
      toplist: [
        {
          type: '',
          title: '首页',
          path: '/'
        },{
          type: 2,
          title: '灾害速报',
          path: '/realtime'
        },{
          type: 3,
          title: '地震灾害数据',
          path: '/earthquake'
        },{
          type: 4,
          title: '防灾减灾数据',
          path: '/prevention'
        },{
          type: 5,
          title: '社会经济数据',
          path: '/society'
        },{
          type: 6,
          title: '统计年鉴',
          path: '/yearbooks'
        }
        ,{
          type: 8,
          title: '政策及预案',
          childs:[
           {
            title:'政策文件',
            path:'/policyment'
           },
           {
            title:'应急预案',
            path:'/emergency'
           },
           {
            title:'自然灾害情况',
            path:'/newlist'
           }
          ],
        },{
          type: 7,
          title: '数据可视化',
          path: '/dataVisualization'
        } 
      ],
      info: '',
     
      path: '',
      type: ''
    }
  },
  mounted() {
    window.onresize = () => { //屏幕尺寸变化就重新赋值
      return (() => {
        this.screenWidth = document.documentElement.clientWidth
      })()
    }
  },
  methods:{
    handleCommand(e){
        if(e==1){
            this.tui()
        }else{
          this.$router.push({path: '/personal'})
        }
    },
    tui(){
      const that = this;
        this.$api.index.logout().then(response => {
          localStorage.setItem("name",'')
          this.$message({
          message: '退出成功',
          type: 'success'
        });
        setTimeout(() => {
          this.$router.push({path: '/'})
        }, 1000);
       })
      // localStorage.setItem("name",'')
      // this.$message({
      //     message: '退出成功',
      //     type: 'success'
      //   });
      //   setTimeout(() => {
      //     this.$router.push({path: '/'})
      //   }, 1000);
         
    },
    logchang(e){ 
      this.$router.push({path: '/login',query:{type:e}})
    },
    tohome(){
        this.$router.push({path: '/'})
    },
    tosearch(){
      // if(!this.keyword){
      //   this.$message.error('请输入搜索内容');
      //   return false;
      // }
      var data = {
        type:this.selectid,
        keyword: this.keyword
      }
      this.selectlist.forEach(item => {
          if(this.selectid == item.value){
            // console.log(item.path)
            this.path = item.path;
          }
      });
      // console.log('this.isSearch',this.isSearch)
      // console.log('this.path',this.path)
      if(this.isSearch == this.path){
        this.$emit('tosearch',JSON.stringify(data))
      }else{
        this.$router.push({
          path: this.path,
          query:{type:this.selectid,keyword: this.keyword}
        })
      }
      
      
    },
    tabselect(res){
      // console.log('res',res)
    },
    changenav(path){
      // this.$emit('navtype',type) 
      if(path=="/dataVisualization"){
        let routeUrl = this.$router.resolve({
            path:path
        })
        window.open(routeUrl.href, '_blank')
      }else{
        this.$router.push({ path: path });
      } 
    },
    tologin(type){
      this.$router.push({path: '/login',query:{type: type}})
    },
    topersonal(){
      if(this.type == 1){
        this.$router.push({path: '/system'})
      }else if(this.type == 2){
        if(!this.info.shop){
          this.$message.error('请先入驻企业');
          setTimeout(() => {
            this.$router.push({path: '/companyinfo'})
          }, 800);
          return false;
        }else{
          if(this.info.shop.status == 0){
            this.$message.info('正在审核中');
          }else if(this.info.shop.status == 1){
            this.$router.push({path: '/personal'})
          }else if(this.info.shop.status == 2){
            this.$message.error('您的申请被拒绝：'+ this.info.shop.remark);
            this.$alert(this.info.shop.remark, '您的申请被拒绝：', {
              confirmButtonText: '重新申请',
              callback: action => {
                this.$router.push({path: '/personal'})
              }
            });
            
          }
        }
      }
    },
     signout() { 
      localStorage.removeItem('name');
      cookies.remove('JSESSIONID')
      this.$store.dispatch('user/logout')
      // this.$router.go(0);
      this.$router.push({path: '/'})
      // logout
    },
  },
  created(){
    this.selectid = this.types ? this.types : '1';
    this.screenWidth = document.documentElement.clientWidth
    this.name = localStorage.getItem("name");
  }

}
</script>

<style>
  /* .el-select .el-input {
    width: 110px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  } */
</style>
<style scoped>
  .headerbox_right_tu{
    width: 30px;
    height: 30px;
    background-color: #f7af34;
    border-radius: 50%;
  }
  .active{
    background-color: #fff;
  }
  .toponenew{
    padding: 0 36px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #ffffff;
  }
  .activenew{
    /* border-radius: 19px; */
    background-color: #fff;color: #fff;
    background-color: #0e42a4;
  }
  .sheight{
    height: 105px;
  }
  .swidth{
    width: 910px;
  }
  .navall{
    height: 65px;
  }
  .navcon{
    /* width:1200px; */
    width: 100%;
    height: 65px;color: #1e1e1e;
  }
.img_all{
  height: 65px;
}
.logo_img{
  height: 45px;
  width: 150px;
  /* object-fit: cover; */
}
.login_text{
  color: #1b4f80;font-size: 14px;margin: 0 10px;
  line-height: 65px;
}
a{
  text-decoration:none;
}
.tttta {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		/* border-top: 1px solid #eee; */
		cursor: pointer;
		border-radius: 10px;
    position: relative;
	}
  .tttta::after{
    position: absolute;
    width: 100%;
    height: 1px;
    content:'';
    top: 0;
    background-color: #eee;
  }
	.tttta:hover {
		background-color: #006bef;
		color: #fff;
	}

	.tttta:first-child::after {
		position: absolute;
    width: 100%;
    height: 0px;
    content:'';
    top: 0;
    background-color: #eee;
	}
</style>


// WEBPACK FOOTER //
// topnav.vue?769fba8e